import $, { speed } from "jquery";
import { Autoplay, EffectFade, Pagination } from "swiper/modules";
import Swiper from "swiper";

Swiper.use([Pagination, Autoplay, EffectFade]);

const topSlider = () => {
  const firstViewSlider = document.querySelector(".top-slider");
  if (!firstViewSlider) return;

  const swiper = new Swiper(".top-slider", {
    autoplay: {
      delay: 3200,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 1600,
    effect: "fade",
    pagination: {
      el: ".swiper-pagination"
    },
  });
}

// .js-target というクラス名を持つ要素を監視し、画面内に入ったら is-active クラスを追加するシンプルな実装
const scrollAnimation = () => {
  // 監視対象の要素をすべて取得
  const targets = document.querySelectorAll(".js-target");
  if (!targets) return; // 監視対象がなければ処理を終了

  // IntersectionObserverのコールバック関数
  const cb = (entries, observer) => {

    entries.forEach((entry) => {
      // 要素がビューポートに入った場合
      if (entry.isIntersecting) {
        // 要素にクラスを追加
        entry.target.classList.add("is-active");
        // 監視を解除
        observer.unobserve(entry.target);
      } else {
        entry.target.classList.remove("is-active");
      }
    });
  };

  // IntersectionObserverのオプション設定
  const options = {
    root: null, // ビューポートを基準にする
    rootMargin: "0px", // ビューポートのマージンを設定
    threshold: 0.4, // 要素が少しでも表示されたら発火
  };

  // IntersectionObserverのインスタンスを作成
  const io = new IntersectionObserver(cb, options);

  // 監視対象の各要素を監視
  targets.forEach((target) => {
    io.observe(target);
  });

};

const menuToggleFunc = () => {
  const mTrigger = document.getElementById("menuTrigger");  // mTriggerを定義

  

  // ハンバーガーアイコンに対しての処理
  if (mTrigger) {
    mTrigger.addEventListener("click", () => {
      document.body.classList.toggle("menu-show");
    });
  }
 
  
};


const formCheck = () => {
  const formPage1 = document.getElementById("formPage1");
  if (!formPage1) return;

  // エラーを表示する関数（error クラスの p 要素を追加して表示）
  function showError(message, this$) {
    let text = this$.parent().find("label").text() + message;
    this$.parent().append(`<p class='error'>${text}</p>`);
  }

  // ラジオボタンのエラー表示用関数
  function showRadioError(groupName, message) {
    const radioGroup = $(`input[name="${groupName}"]`).first().closest('.radio-group, .form-group, fieldset');
    const groupLabel = radioGroup.find('legend, .group-title').text().trim() || groupName;
    radioGroup.append(`<p class='error'>${groupLabel}${message}</p>`);
    return radioGroup;
  }
    
  // チェックボックスのエラー表示用関数
  function showCheckboxError(element, message) {
    const checkboxContainer = $(element).closest('.checkbox-group, .form-group');
    const checkboxLabel = checkboxContainer.find('.input-wrap').text().trim() || $(element).next('label').text().trim();
    checkboxContainer.append(`<p class='error'>${checkboxLabel}${message}</p>`);
    return checkboxContainer;
  }

  // フォームが送信される際のイベントハンドラの設定
  // eslint-disable-next-line consistent-return
  $("#formPage1").submit(() => {
    // エラー表示の初期化
    $("p.error").remove();
    $("div").removeClass("error");
    let text = "";
    $("#errorDispaly").remove();

    // ラジオボタンの必須チェック
    // 検証対象のラジオボタングループ名を配列で定義
    const requiredRadioGroups = ["radio01", "radio02"];
    
    // 各ラジオボタングループの検証
    requiredRadioGroups.forEach(groupName => {
      const radioGroup = $(`input[name="${groupName}"]`);
      if (radioGroup.length > 0 && radioGroup.first().hasClass('required')) {
        // いずれかのラジオボタンが選択されているか確認
        if (!radioGroup.is(':checked')) {
          // エラーメッセージを表示
          showRadioError(groupName, "は必須項目です");
        }
      }
    });

    // 必須チェックボックスの検証
    $('input[type="checkbox"].required').each(function() {
      // チェックボックスがチェックされているか確認
      if (!$(this).is(':checked')) {
        // エラーメッセージを表示
        showCheckboxError(this, "は必須項目です");
      }
    });
    
    // チェックボックスグループの必須検証 (少なくとも1つ選択必要)
    $('.checkbox-group.required').each(function() {
      const checkboxGroup = $(this);
      const checkboxes = checkboxGroup.find('input[type="checkbox"]');
      
      // グループ内のいずれかのチェックボックスが選択されているか確認
      if (!checkboxes.is(':checked')) {
        // グループラベルを取得
        const groupLabel = checkboxGroup.find('.group-title').text().trim() || "選択項目";
        // エラーメッセージを表示
        checkboxGroup.append(`<p class='error'>${groupLabel}から少なくとも1つ選択してください</p>`);
      }
    });

    // メールアドレスの検証
    let email = $.trim($("#email").val());
    if (
      email &&
      // eslint-disable-next-line no-useless-escape
      !/^([a-z0-9\+_\-]+)(\.[a-z0-9\+_\-]+)*@([a-z0-9\-]+\.)+[a-z]{2,6}$/gi.test(email)
    ) {
      $("#email").after("<p class='error'>メールアドレスの形式が異なります</p>");
    }
    // 電話番号の検証
    let tel = $.trim($("#tel").val());
    if (
      tel &&
      // eslint-disable-next-line no-useless-escape
      !/^\(?\d{2,5}\)?[-(\.\s]{0,2}\d{1,4}[-)\.\s]{0,2}\d{3,4}$/gi.test(tel)
    ) {
      $("#tel").after("<p class='error'>電話番号の形式が異なります（半角英数字でご入力ください）</p>");
    }
    // カナの検証
    let kana = $.trim($("#kana").val());
    if (kana && !kana.match(/^[ァ-ヶー]+$/)) {
      $("#kana").after("<p class='error'>全角カタカナではない文字が含まれています</p>");
    }
    // 1行テキスト入力フォームとテキストエリアの検証
    $(":text,textarea")
      .filter(".validate")
      // eslint-disable-next-line func-names
      .each(function () {
        // 必須項目の検証
        $(this)
          .filter(".required")
          // eslint-disable-next-line func-names
          .each(function () {
            if ($(this).val() === "") {
              showError("必須項目です", $(this));
            }
          });
        // 文字数の検証
        $(this)
          .filter(".max30")
          // eslint-disable-next-line func-names
          .each(function () {
            if ($(this).val().length > 30) {
              showError(" は30文字以内です", $(this));
            }
          });
        $(this)
          .filter(".max50")
          // eslint-disable-next-line func-names
          .each(function () {
            if ($(this).val().length > 50) {
              showError(" は50文字以内です", $(this));
            }
          });
        $(this)
          .filter(".max100")
          // eslint-disable-next-line func-names
          .each(function () {
            if ($(this).val().length > 100) {
              showError(" は100文字以内です", $(this));
            }
          });
        $(this)
          .filter(".max1000")
          // eslint-disable-next-line func-names
          .each(function () {
            if ($(this).val().length > 1000) {
              showError(" は1000文字以内でお願いします", $(this));
            }
          });
      });

    // error クラスの追加の処理
    if ($("p.error").length > 0) {
      $("p.error").parent().addClass("error");
      $("html,body").animate({ scrollTop: $("p.error:first").offset().top - 180 }, "slow");
      return false;
    }
  });
};



window.addEventListener('DOMContentLoaded', (event) => {
  menuToggleFunc();
  topSlider();
  scrollAnimation();
  formCheck();
});
